export default "__VITE_ASSET__DHGGiQ9q__"